module.exports = __webpack_public_path__ + "img/nc.2604fa5f.svg";